module.exports = __webpack_public_path__ + "img/login-image.b02e4ad0.jpg";